module.exports = __webpack_public_path__ + "static/media/delete.95aa18f5.svg";